import { render, staticRenderFns } from "./SixDigitConfirmView.vue?vue&type=template&id=3a9b9a22&"
import script from "./SixDigitConfirmView.vue?vue&type=script&lang=ts&"
export * from "./SixDigitConfirmView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports